// ─────────────────────────────────────────────────────────────────────────────
// ACTION TYPES
// ─────────────────────────────────────────────────────────────────────────────

export const SET_EVENTS_LOADING = "SET_EVENTS_LOADING";
export const SET_EVENTS_ERROR   = "SET_EVENTS_ERROR";

// Fetch list
export const FETCH_EVENTS_REQUEST = "FETCH_EVENTS_REQUEST";
export const FETCH_EVENTS_SUCCESS = "FETCH_EVENTS_SUCCESS";
export const FETCH_EVENTS_FAIL    = "FETCH_EVENTS_FAIL";

// Create
export const CREATE_EVENT_REQUEST = "CREATE_EVENT_REQUEST";
export const CREATE_EVENT_SUCCESS = "CREATE_EVENT_SUCCESS";
export const CREATE_EVENT_FAIL    = "CREATE_EVENT_FAIL";

// Update
export const UPDATE_EVENT_REQUEST = "UPDATE_EVENT_REQUEST";
export const UPDATE_EVENT_SUCCESS = "UPDATE_EVENT_SUCCESS";
export const UPDATE_EVENT_FAIL    = "UPDATE_EVENT_FAIL";

// Delete
export const DELETE_EVENT_REQUEST = "DELETE_EVENT_REQUEST";
export const DELETE_EVENT_SUCCESS = "DELETE_EVENT_SUCCESS";
export const DELETE_EVENT_FAIL    = "DELETE_EVENT_FAIL";

// Cancel
export const CANCEL_EVENT_REQUEST = "CANCEL_EVENT_REQUEST";
export const CANCEL_EVENT_SUCCESS = "CANCEL_EVENT_SUCCESS";
export const CANCEL_EVENT_FAIL    = "CANCEL_EVENT_FAIL";

// Replanify
export const REPLANIFY_EVENT_REQUEST = "REPLANIFY_EVENT_REQUEST";
export const REPLANIFY_EVENT_SUCCESS = "REPLANIFY_EVENT_SUCCESS";
export const REPLANIFY_EVENT_FAIL    = "REPLANIFY_EVENT_FAIL";

// Duplicate
export const DUPLICATE_EVENT_REQUEST = "DUPLICATE_EVENT_REQUEST";
export const DUPLICATE_EVENT_SUCCESS = "DUPLICATE_EVENT_SUCCESS";
export const DUPLICATE_EVENT_FAIL    = "DUPLICATE_EVENT_FAIL";

// Export Excel budget
export const EXPORT_BUDGET_REQUEST = "EXPORT_BUDGET_REQUEST";
export const EXPORT_BUDGET_FAIL    = "EXPORT_BUDGET_FAIL";

// Export Excel formations
export const EXPORT_FORMATIONS_REQUEST = "EXPORT_FORMATIONS_REQUEST";
export const EXPORT_FORMATIONS_FAIL    = "EXPORT_FORMATIONS_FAIL";

// ── Import Excel ──────────────────────────────────────────────────────────────
export const IMPORT_EVENTS_EXCEL_REQUEST = "IMPORT_EVENTS_EXCEL_REQUEST";
export const IMPORT_EVENTS_EXCEL_SUCCESS = "IMPORT_EVENTS_EXCEL_SUCCESS";
export const IMPORT_EVENTS_EXCEL_FAIL    = "IMPORT_EVENTS_EXCEL_FAIL";

// ── Export Excel ──────────────────────────────────────────────────────────────
export const EXPORT_EVENTS_EXCEL_REQUEST = "EXPORT_EVENTS_EXCEL_REQUEST";
export const EXPORT_EVENTS_EXCEL_SUCCESS = "EXPORT_EVENTS_EXCEL_SUCCESS";
export const EXPORT_EVENTS_EXCEL_FAIL    = "EXPORT_EVENTS_EXCEL_FAIL";

// ── Template import ───────────────────────────────────────────────────────────
export const DOWNLOAD_EVENTS_TEMPLATE_REQUEST = "DOWNLOAD_EVENTS_TEMPLATE_REQUEST";
export const DOWNLOAD_EVENTS_TEMPLATE_SUCCESS = "DOWNLOAD_EVENTS_TEMPLATE_SUCCESS";
export const DOWNLOAD_EVENTS_TEMPLATE_FAIL    = "DOWNLOAD_EVENTS_TEMPLATE_FAIL";

export const SEND_EVENT_CALENDAR_REQUEST = "SEND_EVENT_CALENDAR_REQUEST";
export const SEND_EVENT_CALENDAR_SUCCESS = "SEND_EVENT_CALENDAR_SUCCESS";
export const SEND_EVENT_CALENDAR_FAIL = "SEND_EVENT_CALENDAR_FAIL";

export const DOWNLOAD_EVENT_ATTENDANCE_SHEET_REQUEST = "DOWNLOAD_EVENT_ATTENDANCE_SHEET_REQUEST";
export const DOWNLOAD_EVENT_ATTENDANCE_SHEET_SUCCESS = "DOWNLOAD_EVENT_ATTENDANCE_SHEET_SUCCESS";
export const DOWNLOAD_EVENT_ATTENDANCE_SHEET_FAIL = "DOWNLOAD_EVENT_ATTENDANCE_SHEET_FAIL";

// ─────────────────────────────────────────────────────────────────────────────
// ACTION CREATORS
// ─────────────────────────────────────────────────────────────────────────────

export const setEventsLoading = (v)   => ({ type: SET_EVENTS_LOADING, payload: v });
export const setEventsError   = (msg) => ({ type: SET_EVENTS_ERROR, payload: msg });

// Fetch
export const fetchEventsRequest = ()     => ({ type: FETCH_EVENTS_REQUEST });
export const fetchEventsSuccess = (data) => ({ type: FETCH_EVENTS_SUCCESS, payload: data });
export const fetchEventsFail    = (err)  => ({ type: FETCH_EVENTS_FAIL, payload: err });

// Create
export const createEventRequest = (payload) => ({ type: CREATE_EVENT_REQUEST, payload });
export const createEventSuccess = (data)    => ({ type: CREATE_EVENT_SUCCESS, payload: data });
export const createEventFail    = (err)     => ({ type: CREATE_EVENT_FAIL, payload: err });

// Update
export const updateEventRequest = (id, payload) => ({
    type: UPDATE_EVENT_REQUEST,
    payload: { id, payload }
});
export const updateEventSuccess = (data) => ({ type: UPDATE_EVENT_SUCCESS, payload: data });
export const updateEventFail    = (err)  => ({ type: UPDATE_EVENT_FAIL, payload: err });

// Delete
export const deleteEventRequest = (id)  => ({ type: DELETE_EVENT_REQUEST, payload: { id } });
export const deleteEventSuccess = (id)  => ({ type: DELETE_EVENT_SUCCESS, payload: id });
export const deleteEventFail    = (err) => ({ type: DELETE_EVENT_FAIL, payload: err });

// Cancel
export const cancelEventRequest = (id)   => ({ type: CANCEL_EVENT_REQUEST, payload: { id } });
export const cancelEventSuccess = (data) => ({ type: CANCEL_EVENT_SUCCESS, payload: data });
export const cancelEventFail    = (err)  => ({ type: CANCEL_EVENT_FAIL, payload: err });

// Replanify
export const replanifyEventRequest = (dto)  => ({ type: REPLANIFY_EVENT_REQUEST, payload: dto });
export const replanifyEventSuccess = (data) => ({ type: REPLANIFY_EVENT_SUCCESS, payload: data });
export const replanifyEventFail    = (err)  => ({ type: REPLANIFY_EVENT_FAIL, payload: err });

// Duplicate
export const duplicateEventRequest = (id)   => ({ type: DUPLICATE_EVENT_REQUEST, payload: { id } });
export const duplicateEventSuccess = (data) => ({ type: DUPLICATE_EVENT_SUCCESS, payload: data });
export const duplicateEventFail    = (err)  => ({ type: DUPLICATE_EVENT_FAIL, payload: err });

// Budget / formations
export const exportBudgetRequest = () => ({ type: EXPORT_BUDGET_REQUEST });
export const exportBudgetFail    = (err) => ({ type: EXPORT_BUDGET_FAIL, payload: err });

export const exportFormationsRequest = () => ({ type: EXPORT_FORMATIONS_REQUEST });
export const exportFormationsFail    = (err) => ({ type: EXPORT_FORMATIONS_FAIL, payload: err });

// Import Excel
// export const importEventsExcelRequest = (file, dryRun, action) => ({
//     type: IMPORT_EVENTS_EXCEL_REQUEST,
//     payload: { file, dryRun, action },
// });
export const importEventsExcelRequest = (
    file,
    dryRun,
    action,
    evaluationIds = [],
    numberOfDaysHot = 1,
    numberOfDaysCold = 120
) => ({
    type: IMPORT_EVENTS_EXCEL_REQUEST,
    payload: {
        file,
        dryRun,
        action,
        evaluationIds,
        numberOfDaysHot,
        numberOfDaysCold,
    },
});
export const importEventsExcelSuccess = (data) => ({
    type: IMPORT_EVENTS_EXCEL_SUCCESS,
    payload: data,
});
export const importEventsExcelFail = (err) => ({
    type: IMPORT_EVENTS_EXCEL_FAIL,
    payload: err,
});

// Export Excel
export const exportEventsExcelRequest = () => ({
    type: EXPORT_EVENTS_EXCEL_REQUEST,
});
export const exportEventsExcelSuccess = () => ({
    type: EXPORT_EVENTS_EXCEL_SUCCESS,
});
export const exportEventsExcelFail = (err) => ({
    type: EXPORT_EVENTS_EXCEL_FAIL,
    payload: err,
});

// Download template
export const downloadEventsTemplateRequest = () => ({
    type: DOWNLOAD_EVENTS_TEMPLATE_REQUEST,
});
export const downloadEventsTemplateSuccess = () => ({
    type: DOWNLOAD_EVENTS_TEMPLATE_SUCCESS,
});
export const downloadEventsTemplateFail = (err) => ({
    type: DOWNLOAD_EVENTS_TEMPLATE_FAIL,
    payload: err,
});

export const sendEventCalendarRequest = (eventId, actionType) => ({
    type: SEND_EVENT_CALENDAR_REQUEST,
    payload: { eventId, actionType },
});
export const sendEventCalendarSuccess = (data) => ({
    type: SEND_EVENT_CALENDAR_SUCCESS,
    payload: data,
});
export const sendEventCalendarFail = (err) => ({
    type: SEND_EVENT_CALENDAR_FAIL,
    payload: err,
});

export const downloadEventAttendanceSheetRequest = (eventId) => ({
    type: DOWNLOAD_EVENT_ATTENDANCE_SHEET_REQUEST,
    payload: { eventId },
});
export const downloadEventAttendanceSheetSuccess = () => ({
    type: DOWNLOAD_EVENT_ATTENDANCE_SHEET_SUCCESS,
});
export const downloadEventAttendanceSheetFail = (err) => ({
    type: DOWNLOAD_EVENT_ATTENDANCE_SHEET_FAIL,
    payload: err,
});
